import React, {
    useState,
    useEffect,
    useCallback
} from "react";
import {
    Row,
    Col,
    Form
} from "react-bootstrap";
import { setToLS } from "../../../utils/storage";
import { ComparisonFullWindowModal } from "../CompareK1Page/ComparisonFullWindowModal";
import { SummaryComparisonFullWindowModal } from "../SummaryComparisonFullWindowModal";
import { ReturnModal } from "../ReturnModal";
import { ExcelExportModal } from "./ExcelExportModal";
import { UploadKonePdf } from "./UploadKoneModal";
import { ConfirmationModal } from "./K1ConfirmationModal";
import { MyKonesGrid } from "./MainK1GridRenderer";
import { DownloadSummaryExcel, DownloadURI } from "./K1HelperFunctions";
import { makeCygnusApiCall } from "../../../api/api";
import { CustomToaster } from "../../../reusable-components/Toasters/toaster";
import { CustomButton } from "../../../reusable-components/CustomButtonComponent/button";
import RefreshButton from "../../../reusable-components/CustomButtonComponent/RefreshButton";
import * as Icon from "react-bootstrap-icons";
import { toast } from "react-toastify";
import { K1ChangeHistoryModal } from "../K1ChangeHistoryModal";
// css
import "./konehome.css";

const MyKones = (props) => {
    const [dataSource, setDataSource] = useState([]);
    const [myKonesRowData, setMyKonesRowData] = useState([])
    const [contextGridApi, setContextGridApi] = useState();
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [fileUploadingFlag, setFileUploadingFlag] = useState(false);
    const [summarizingFlag, setSummarizingFlag] = useState(false);
    const [importToTaxFlag, setImportToTaxFlag] = useState(false);
    const [refreshGridFlag, setRefreshGridFlag] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [bulkLinks, setBulkLinks] = useState([]);
    const [confirmationModal, setConfirmationModal] = useState(false);
    const [returnModal, setReturnModal] = useState(false);
    const [showExcelExportModal, setShowExcelExportModal] = useState(false);
    const [comparisonWindowModalState, setComparisonWindowModalState] = useState(false);
    const [summaryComparisonWindowModalState, setSummaryComparisonWindowModalState] = useState(false);
    const [k1ChangeHistoryModalState, setK1ChangeHistoryModalState] = useState(false);
    const [uploadKoneModal, setUploadKoneModalShow] = useState(false);
    const [comparisonData, setComparisonData] = useState([]);
    const [summaryComparisonData, setSummaryComparisonData] = useState([]);
    const [k1ChangeHistoryData, setK1ChangeHistoryData] = useState({});
    const [totalPagesOfSelectedFile, setTotalPages] = useState(0);
    const [gridMessage, setGridMessage] = useState("Loading K-1s...");

    const [searchText, setSearchText] = useState("");

    const [totalK1s, setTotalK1s] = useState(0);
    const [verifiedK1s, setVerifiedK1s] = useState(0);
    const [inProgressK1s, setInProgressK1s] = useState(0);
    const [erroredK1s, setErroredK1s] = useState(0);
    const [uniquePartners, setUniquePartners] = useState(0);

    const onSearchTextChange = (event) => {
        setSearchText(event.target.value);
    }

    /**
     * Make API call to fetch all kones for the firm.
     */
    const getAllKones = async () => {
        setRefreshGridFlag(true)
        const all_kones = await makeCygnusApiCall({
            type: "GET",
            payload: {},
            url: "/k1/",
            show_message: false,
            customized_success_message: "Got your K-1s. Let the games begin.",
            customized_failure_message: "Unable to fetch your K-1s, please contact support and attach a screenshot.",
            isblob: false
        })
        if (all_kones !== undefined) {
            if (all_kones["data"].length === 0) {
                // alert("No K-1s found. Upload a K-1 file to get started.")
                setGridMessage("No K-1s found. Upload a K-1 file to get started.")
            }
            setData(all_kones)
        }
    }

    /**
     * Formatting and setting the API response to grid row data.
     * @param {*} data : API response used for updating the grid data.
     */
    const setData = (data) => {
        console.log("incoming data frm cygnus api", data);
        setDataSource(data['data'])
        const rows = []
        for (let record of data["data"]) {
            rows.push({
                "K1Name": record["FileName"]["placeholder"],
                "K1File": record["FileName"]["url"],
                "K1Type": record["K1Type"],
                "Status": record["Status"],
                "ActiveKone": record,
                "ApiData": data["data"]
            })
        }
        setMyKonesRowData(rows)
        setRefreshGridFlag(false)
        redrawGrid();

        const metadata = data["metadata"] || {};
        setTotalK1s(metadata["Total"] || 0);
        setVerifiedK1s(metadata["Verified"] || 0);
        setInProgressK1s(metadata["InProgress"] || 0);
        setErroredK1s(metadata["Error"] || 0);
        setUniquePartners(metadata["UniquePartners"] || 0);

    }

    /**
     * Redraw the gird to adjust width and fit the grid to available width.
     */
    const redrawGrid = () => {
        if (contextGridApi !== undefined) {
            contextGridApi.sizeColumnsToFit()
        }
    }

    /**
     * A callback to get the context ready for the grid.
     */
    const onContextGridReady = useCallback((params) => {
        setContextGridApi(params.api)
        params.api.closeToolPanel();
    })

    /**
     * Exporting selected kones into a custom summary excel and downloading the files.
     */
    const exportSelectedKones = () => {
        const links = []
        for (let obj of selectedRows) {
            if (obj.ActiveKone.Status === "Verified") {
                const link = `${process.env.REACT_APP_BASE_URI}/workflow/k1/export/${obj.ActiveKone['K1FileId']}/`
                links.push(link)
            }
        }
        setBulkLinks(links)
    }

    /**
     * Summarizing the selected K-1s and downloading the summary excel file.
     */
    const summarizeSelectedKones = async () => {
        setSummarizingFlag(true)
        let selectedData = contextGridApi.getSelectedRows();
        let selectedFileIds = []
        for (let obj of selectedData) {
            selectedFileIds.push(obj["ActiveKone"]["K1FileId"])
        }
        const summaryBlob = await makeCygnusApiCall({
            type: "POST",
            payload: selectedFileIds,
            url: "/k1/export/",
            show_message: true,
            customized_success_message: "Summarized your K-1s. Please check the downloads for a summary.xlsx file",
            customized_failure_message: "Unable to summarize your K-1s, please contact support and attach a screenshot.",
            customized_error_message: "Error occured while summarizing your K-1s to tax, please contact support and attach a screenshot.",
            isblob: true
        })
        await DownloadSummaryExcel(summaryBlob)
        setSummarizingFlag(false)
    }



    /**
     * Process the selected rows to get all K-1 IDs and use ti to make an API call along with user input Return ID.
     * @param {*} selectedRows : Selected K-1s to be imported to the tax.
     * @param {*} returnId : The Return ID to import the K-1s into.
     */
    const importSelectedKonesToTax = async (selectedRows, returnId) => {
        setImportToTaxFlag(true)
        const k1_file_ids = []
        for (let row of selectedRows) {
            k1_file_ids.push(row["ActiveKone"]["K1FileId"])
        }

        let payloadformat
        if (returnId !== undefined) {
            payloadformat = {
                "K1FileIds": k1_file_ids,
                "ReturnId": returnId
            }
        } else {
            CustomToaster({
                success: false,
                customized_message: "Please enter a valid return ID!",
                api_message: ""
            })
        }

        // No use of the response so ignoring it
        const _ = await makeCygnusApiCall({
            type: "POST",
            payload: payloadformat,
            url: "/k1/send_to_tax/",
            show_message: true,
            customized_success_message: "Imported your K-1s to tax.",
            customized_failure_message: "Unable to import your K-1s to tax, please contact support and attach a screenshot.",
            customized_error_message: "Error occured while importing your K-1s to tax, please contact support and attach a screenshot.",
            isblob: false
        })
        setImportToTaxFlag(false)
    }

    /**
     * Functionality to remove the cached dat from localstorage after moving to a different page.
     */
    const removeCachedPages = () => {
        for (let count = 1; count <= totalPagesOfSelectedFile; count++) {
            localStorage.removeItem(`Page ${count}`)
        }
    }

    /**
     * Setting page url for helper function
     */
    useEffect(() => {
        setToLS("url", ["mykones"])
    }, [])

    /**
     * Make a default API call to get the initial set of data.
     */
    useEffect(() => {
        getAllKones()
    }, [])

    /**
     * Calling the download url function for every selected file link.
     */
    useEffect(() => {
        if (bulkLinks.length >= 1) {
            for (let url of bulkLinks) {
                DownloadURI(url, "file.xlsx")
            }
        }
    }, [bulkLinks])

    /**
     * Updating the flag for enabling and disabling the Import and Summarize buttons.
     */
    useEffect(() => {
        if (selectedRows != undefined) {
            if (selectedRows.length > 0) {
                setIsButtonDisabled(false)
            } else {
                setIsButtonDisabled(true)
            }
        }
    }, [selectedRows]);


    const searchK1Files = async () => {
        //    alert(searchText);
        setRefreshGridFlag(true)
        const url = `${process.env.REACT_APP_BASE_URI}/workflow/k1/search/`;
        // alert("Return Ids are being generated. Please wait for the download to start.")
        const payload = {
            "SearchKey": searchText
        }
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem("token")}`,
        }
        // Add your search logic here
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(payload)
            },);
            const data = await response.json();
            console.log("DATA: ", data);

            if (data["data"].length === 0) {
                // alert("No K-1s found. Upload a K-1 file to get started.")
                setGridMessage("No files found based on the search.")
            }

            setData(data)
            setRefreshGridFlag(false);

        }
        catch {
            toast.error("Something went wrong.", {
                position: "bottom-right",
                autoClose: 2500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                className: "toastify-color-error",
            });
            setRefreshGridFlag(false);
        }
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault(); // Prevent form submission if inside a form
            searchK1Files();
        }
    };

    return (
        <>
            {dataSource.length > 0 &&
                <>
                    {comparisonWindowModalState &&
                    <ComparisonFullWindowModal
                        show={comparisonWindowModalState}
                        onHide={() => {
                            setComparisonWindowModalState(false)
                            removeCachedPages()
                        }
                        }
                        comparisondata={comparisonData}
                        settotalpages={(pages) => setTotalPages(pages)}
                        refresh={() => getAllKones()}
                    />}
                    <SummaryComparisonFullWindowModal
                        show={summaryComparisonWindowModalState}
                        onHide={() => {
                            setSummaryComparisonWindowModalState(false)
                            removeCachedPages()
                        }}
                        summarycomparisondata={summaryComparisonData}
                        settotalpages={(pages) => setTotalPages(pages)}
                        refresh={() => getAllKones()}
                    />
                </>
            }

            <ConfirmationModal
                show={confirmationModal}
                onHide={() => setConfirmationModal(false)}
                bulklinks={bulkLinks}
            />

            <ReturnModal
                show={returnModal}
                submit={(returnId) => importSelectedKonesToTax(selectedRows, returnId)}
                onHide={() => setReturnModal(false)}
                selectedrows={selectedRows}
            />

            <ExcelExportModal
                show={showExcelExportModal}
                // submit={(returnId) => importSelectedKonesToTax(selectedRows, returnId)}
                onHide={() => setShowExcelExportModal(false)}
                selectedrows={selectedRows}
            />

            <UploadKonePdf
                show={uploadKoneModal}
                onHide={() => setUploadKoneModalShow(false)}
                refresh={() => getAllKones()}
                setfileuploading={(flag) => setFileUploadingFlag(flag)}
            />

            {k1ChangeHistoryModalState && 
                <K1ChangeHistoryModal
                    show={k1ChangeHistoryModalState}
                    K1FileId={k1ChangeHistoryData.K1FileId}
                    FileName={k1ChangeHistoryData.FileName}
                    onHide={() => setK1ChangeHistoryModalState(false)}
                />
            }

            <Row className="no-gutter">
                <Col md={12}>
                    <p className="display-6" style={{ height: "fit-content", marginBottom: 10 }}>My K-1s</p>
                    <div className="flex-row-center-end">
                        <div className="flex-row-center-center fit-content" style={{ marginTop: 15 }}>
                            <CustomButton
                                progress={fileUploadingFlag}
                                onclick={() => setUploadKoneModalShow(true)}
                                content={fileUploadingFlag ? "Uploading" : "Upload K-1"}
                            />
                            {/* setReturnModal */}
                            <CustomButton
                                progress={importToTaxFlag}
                                onclick={() => setShowExcelExportModal(true)}

                                content={importToTaxFlag ? "Importing" : "Import to tax"}
                                disable={isButtonDisabled}
                            />
                            <CustomButton
                                progress={summarizingFlag}
                                onclick={() => setShowExcelExportModal(true)}
                                content={summarizingFlag ? "Summarizing" : "Export to excel "}
                                disable={isButtonDisabled}
                            />
                            <RefreshButton
                                refreshflag={refreshGridFlag}
                                refreshfunction={() => getAllKones()}
                            />
                        </div>
                        <div style={{ width: 200 }}></div>
                    </div>
                </Col>
                <Col md={7} className="flex-row-end-start">
                    <div className="k1-topchart-summary-div">
                        <div>
                            <p className="k1-topchart-summary"> <Icon.FilePlusFill /> Total K1s: {totalK1s}</p>
                            <p className="k1-topchart-summary"><Icon.CheckCircleFill /> Verified: {verifiedK1s}</p>
                            <p className="k1-topchart-summary"><Icon.Hammer /> In Progress: {inProgressK1s}</p>
                            <p className="k1-topchart-summary"><Icon.BugFill /> Errored: {erroredK1s}</p>
                            <p className="k1-topchart-summary-last"><Icon.PeopleFill /> Unique Partners: {uniquePartners}</p>
                        </div>
                        <div style={{ padding: "0px 10px", width: "100%", textAlign: "center", marginTop: 10, marginBottom: -5 }}>
                            <hr/>
                        </div>
                    </div>
                    <div style={{ width: 20, marginTop: -28, height: 30 }}>
                        <div className="styler"></div>
                        <div className="styler-2"></div>
                    </div>
                </Col>
                <Col md={5} style={{ position: "relative", marginBottom: 5, marginLeft: -15 }}>
                    <div className="flex-row-center-end">
                        <Form.Control
                            type="text"
                            className="form-control custom-input"
                            placeholder="Search"
                            value={searchText}
                            onChange={onSearchTextChange} // Trigger search on input change
                            id=""
                            onKeyDown={handleKeyPress} // Trigger search on Enter key press
                        />
                        <Icon.Search
                            className="search-icon"
                            onClick={searchK1Files} // Trigger search on click
                            style={{
                                position: "absolute",
                                top: "50%",
                                right: "20px",
                                transform: "translateY(-50%)",
                                fontSize: "16px",
                                color: "#888",
                                cursor: "pointer"
                            }}
                        />
                    </div>
                </Col>
                <Col md="12" className="grid-row" style={{ minHeight: "79vh" }}>
                    <MyKonesGrid
                        rowData={myKonesRowData}
                        onGridReady={onContextGridReady}
                        setcomparefullwindowmodal={(flag) => setComparisonWindowModalState(flag)}
                        setsummarycomparefullwindowmodal={(flag) => setSummaryComparisonWindowModalState(flag)}
                        setk1changehistorymodal={(flag) => setK1ChangeHistoryModalState(flag)}
                        setcomparisondata={(data) => setComparisonData(data)}
                        setsummarycomparisondata={(data) => setSummaryComparisonData(data)}
                        setk1changehistorydata={(data) => setK1ChangeHistoryData(data)}
                        setselectedrows={(rows) => setSelectedRows(rows)}
                        gridMessage={gridMessage}
                    />
                </Col>
            </Row>
        </>
    )
}

export default MyKones;